<script>
  import { fade } from 'svelte/transition'
  import AboutStory from './AboutStory.svelte'
  import MissionVision from './MissionVision.svelte'
  import Team from './Team.svelte'
  import FinalCta from '../(landing-components)/FinalCTA.svelte'
</script>

<svelte:head>
  <title>AddMeetings | About</title>
</svelte:head>

<div class="container mx-auto px-4 py-24 md:py-32 md:px-16 lg:px-24 flex flex-col items-center justify-center">
  <div class="mx-auto text-center space-y-6" in:fade={{ duration: 300, delay: 150 }}>
    <h2 class="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
      <span class="text-am-black">About</span>
      <span class="text-am-white-60">AddMeetings</span>
    </h2>

    <p class="text-am-black-75 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto">
      Say goodbye to cold meeting requests. Just say “Meet me on AddMeetings,” where only high-value meeting requests land in your inbox, helping you save time and have the right conversations that move your business forward.
    </p>
  </div>
  <div class="w-full rounded-2xl mt-20 max-h-[95vh] aspect-video overflow-hidden">
    <img
      src="/in_a_meeting.webp"
      alt="The founder of AddMeetings"
      class="w-full h-full object-cover"
    />
  </div>
  <AboutStory />
  <MissionVision />
  <Team />
  <FinalCta class="rounded-3xl w-full" />
</div>

<style>
  /* Optional: Add text shadow for better contrast */
  h2 {
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
</style>
